export default __webpack_public_path__ + "static/media/weightlosswithfamily@2x.1d390427.jpg";